(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lpv-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lpv-mobile-purchase')) {
    customElements.define('lpv-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        this.info = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
        this.originalButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
        if (!this.root || !this.info || !this.originalButton) return;

        this.media = this.root.querySelector('.product__media-wrapper');
        this.mediaParent = this.media?.parentElement;
        this.mediaNext = this.media?.nextElementSibling;
        this.buyBlock = this.originalButton.closest('product-form').parentElement;
        this.buyButtons = this.originalButton.closest('.product-form__buttons');
        this.imageCarousel = this.root.hasAttribute('data-lpv-image-carousel');
        this.quantityBlock = this.root.hasAttribute('data-lpv-glance') || this.imageCarousel ? this.root.querySelector('.product-form__quantity') : null;
        this.quantityParent = this.quantityBlock?.parentElement;
        this.quantityNext = this.quantityBlock?.nextElementSibling;
        this.help = this.querySelector('.lpv-mobile-help');
        this.dock = this.querySelector('.lpv-purchase-dock');
        this.button = this.querySelector('[data-lpv-add]');
        this.price = this.querySelector('[data-lpv-price]');
        this.unitPrice = this.querySelector('[data-lpv-dock-unit]');
        this.optionSelects = [...this.querySelectorAll('[data-lpv-option]')];
        this.quantityLabel = this.querySelector('[data-lpv-quantity]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.abort = new AbortController();
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.sync();
          });
        };
        this.reflow = () => {
          if (this.mobile.matches) {
            if (this.quantityBlock) {
              this.originalButton.before(this.quantityBlock);
              this.buyButtons.classList.add('lpv-compact-buy');
            }
            this.buyBlock.after(this.help);
            if (this.media) {
              if (this.imageCarousel) this.info.querySelector('.product__title').after(this.media);
              else this.help.after(this.media);
            }
          } else {
            if (this.quantityBlock) {
              this.quantityParent.insertBefore(this.quantityBlock, this.quantityNext);
              this.buyButtons.classList.remove('lpv-compact-buy');
            }
            this.prepend(this.help);
            if (this.media) this.mediaParent.insertBefore(this.media, this.mediaNext);
          }
          this.sync();
        };

        this.mobile.addEventListener('change', this.reflow, {signal: this.abort.signal});
        addEventListener('scroll', this.schedule, {passive: true, signal: this.abort.signal});
        addEventListener('resize', this.schedule, {passive: true, signal: this.abort.signal});
        this.root.addEventListener('input', this.schedule, {signal: this.abort.signal});
        this.root.addEventListener('change', this.schedule, {signal: this.abort.signal});
        this.optionSelects.forEach(select => {
          select.addEventListener('change', () => {
            const groups = this.root.querySelectorAll('variant-selects fieldset, variant-selects select');
            const group = groups[Number(select.dataset.lpvOption)];
            const input = group?.tagName === 'SELECT' ? group :
              [...(group?.querySelectorAll('input[type="radio"]') || [])].find(radio => radio.value === select.value);
            if (!input) return this.sync();
            if (input.tagName === 'SELECT') input.value = select.value;
            else input.checked = true;
            input.dispatchEvent(new CustomEvent('change', {
              bubbles: true, detail: {lpvFocusTarget: select.id}
            }));
            this.sync();
          }, {signal: this.abort.signal});
        });
        this.button.addEventListener('click', () => {
          this.sync();
          if (!this.button.disabled) {
            this.fromDock = true;
            this.originalButton.click();
          }
        }, {signal: this.abort.signal});

        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, {
          subtree: true, childList: true, characterData: true, attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'value', 'class', 'hidden']
        });
        this.previewResize = new ResizeObserver(this.schedule);
        this.previewChanges = new MutationObserver(this.schedule);
        this.previewChanges.observe(document.body, {childList: true});
        this.reflow();
      }

      sync() {
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        if (previewBar !== this.previewBar) {
          this.previewResize.disconnect();
          this.previewBar = previewBar;
          if (previewBar) this.previewResize.observe(previewBar);
        }
        const previewRect = previewBar?.getBoundingClientRect();
        const previewVisible = previewRect?.height > 0 && getComputedStyle(previewBar).visibility !== 'hidden';
        const previewOffset = previewVisible ? Math.max(0, innerHeight - previewRect.top) : 0;
        this.dock.style.setProperty('--lpv-preview-offset', `${previewOffset}px`);
        const disabled = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = disabled;
        const buttonText = this.originalButton.querySelector('span')?.textContent.trim() || this.originalButton.textContent.trim();
        if (this.button.textContent !== buttonText) this.button.textContent = buttonText;
        const priceRoot = document.getElementById(`price-${this.dataset.sectionId}`);
        const priceNode = priceRoot?.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular');
        if (priceNode && this.price.textContent !== priceNode.textContent.trim()) this.price.textContent = priceNode.textContent.trim();
        const unitText = priceRoot?.querySelector('[data-lpv-unit-text]')?.textContent.trim() || '';
        this.unitPrice.hidden = !unitText;
        if (this.unitPrice.textContent !== unitText) this.unitPrice.textContent = unitText;
        const groups = this.root.querySelectorAll('variant-selects fieldset, variant-selects select');
        this.optionSelects.forEach(select => {
          const group = groups[Number(select.dataset.lpvOption)];
          if (!group) return;
          const selected = group.tagName === 'SELECT' ? group : group.querySelector('input:checked');
          if (selected) select.value = selected.value;
          const values = [...group.querySelectorAll('input[type="radio"], option')];
          [...select.options].forEach(option => {
            const native = values.find(value => value.value === option.value);
            if (!native) return;
            const optionText = native.tagName === 'OPTION' ? native.textContent.trim() :
              native.classList.contains('disabled') ? option.dataset.lpvUnavailable : option.value;
            if (option.textContent !== optionText) option.textContent = optionText;
          });
        });
        const quantity = this.root.querySelector('.quantity__input')?.value || '1';
        this.quantityLabel.hidden = quantity === '1';
        this.quantityLabel.textContent = ` × ${quantity}`;
        const rect = this.originalButton.getBoundingClientRect();
        this.dock.hidden = !this.mobile.matches || rect.bottom > 0;

        const error = this.root.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (this.fromDock && error?.textContent.trim()) {
          this.fromDock = false;
          error.scrollIntoView({block: 'center', behavior: 'smooth'});
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.previewResize?.disconnect();
        this.previewChanges?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
